export default "__VITE_ASSET__hteZSJXH__"